import React, { useState, useEffect } from "react";
import NavBarTop from '../../NavBar_Top/NavBar_Top';
import Carrossel from '../../Carrossel/Carrossel';
import Carrossel_mini from '../../Carrossel_mini/Carrossel_mini';
import Rodape from '../../Rodape/Rodape';
import { ToastContainer, toast } from 'react-toastify';
import { BrowserView, MobileView } from 'react-device-detect';
import api from '../../../services/api';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import ConfirmacaoIcone from '../../../assets/img/confirmacao.svg';
import { fontSize } from '@mui/system';
import Typography from "@mui/material/Typography";

function PaginaLinkPagamentoPago(props) {
    return (
        (props != null && props.props != null
            ?
            <div>
                <BrowserView>
                       <Grid container height={'433px'} direction="row"
                        sx={{
                            justifyContent: "center",
                            alignItems: "center",
                        }}>
                        <Grid item xs={4}>
                            <Box display="flex" justifyContent="flex-end">
                                <img src={ConfirmacaoIcone} alt="!" style={{ width: '70px', height: 'auto' }} />
                            </Box>
                        </Grid>
                        <Grid item xs={8} sx={{ alignItems: "left", paddingLeft: "10px" }}>
                            <Box display="flex" justifyContent="flex-start">
                                <Typography sx={{ fontSize: "20px" }}>{props.props.cabecalho}</Typography>
                            </Box>
                            <Box display="flex" justifyContent="flex-start">
                                {props.props.corpo}
                            </Box>
                        </Grid>
                    </Grid>
                </BrowserView>

                <MobileView>
                    <Grid container height={'433px'} direction="row"
                        sx={{
                            justifyContent: "center",
                            alignItems: "center",
                        }}>
                        <Grid item xs={4}>
                            <Box display="flex" justifyContent="flex-end">
                                <img src={ConfirmacaoIcone} alt="!" style={{ width: '70px', height: 'auto' }} />
                            </Box>
                        </Grid>
                        <Grid item xs={8} sx={{ alignItems: "left", paddingLeft: "10px" }}>
                            <Box display="flex" justifyContent="flex-start">
                                <Typography sx={{ fontSize: "20px" }}>{props.props.cabecalho}</Typography>
                            </Box>
                            <Box display="flex" justifyContent="flex-start">
                                {props.props.corpo}
                            </Box>
                        </Grid>
                    </Grid>
                </MobileView>
                <ToastContainer />
            </div>

            :
            
            <></>
        )
    )
}
export default PaginaLinkPagamentoPago